import { render, staticRenderFns } from "./DFieldThumbnail.vue?vue&type=template&id=22efa145&"
import script from "./DFieldThumbnail.vue?vue&type=script&lang=js&"
export * from "./DFieldThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports